import React from 'react';

const Loader = () => <div>''</div>;
export default Loader;
